import React, { useState } from "react";
import styled from "styled-components";
import { API_HOST } from "../../config";
import axios from "../../modules/axiosInstance";

import { IAdminRegisterModal } from "../../customHook/NavigationBarHook";
import Button from "../atoms/Button";
import Form from "../molecules/Form";
import FormInput from "../molecules/FormInput";
import Modal from "../molecules/Modal";

import { IStringTMap } from "../../interfaces";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  modalState: IAdminRegisterModal;
}

export interface IAdminUserInfo extends IStringTMap<string> {
  name: string;
  email: string;
  password: string;
}

const AdminRegisterModal: React.FC<IProps> = ({ modalState, ...props }) => {
  const [adminRegisterForm, changeAdminRegisterForm] = useState<IAdminUserInfo>(
    {
      name: "",
      email: "",
      password: ""
    }
  );

  const validateInput = (): boolean => {
    for (const prop in adminRegisterForm) {
      if (adminRegisterForm[prop] === "") {
        alert("全ての項目を埋めてください。");
        return false;
      }
    }
    return true;
  };

  const handleRegisterSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!validateInput()) return;

    const apiUrl = `${API_HOST}/api/admins`;
    const params = new URLSearchParams();
    params.append("email", adminRegisterForm.email);
    params.append("password", adminRegisterForm.password);
    params.append("name", adminRegisterForm.name);
    axios
      .post(apiUrl, params)
      .then(r => {
        alert("アドミンユーザーが追加されました。");
      })
      .catch(e => {
        alert("アドミンユーザーの追加に失敗しました。");
      });
    modalState.close();
  };

  const changeFormEachItem = (item: string, value: string) => {
    // reference: https://reactjs.org/docs/hooks-reference.html#functional-updates
    changeAdminRegisterForm(prevState => {
      prevState[item] = value;
      return { ...prevState };
    });
  };

  return (
    <Modal
      {...props}
      title={"Admin ユーザーの登録"}
      content={
        <>
          <Form>
            <FormInput
              items={[
                {
                  key: "name",
                  value: adminRegisterForm.name,
                  placeholder: "名前",
                  type: "text",
                  required: true
                },
                {
                  type: "email",
                  key: "email",
                  value: adminRegisterForm.email,
                  placeholder: "メール",
                  required: true
                },
                {
                  type: "password",
                  key: "password",
                  value: adminRegisterForm.password,
                  placeholder: "パスワード",
                  required: true
                }
              ]}
              onChangeEachItem={changeFormEachItem}
            />
          </Form>
          <ButtonAlign>
            <CancelButton title={"キャンセル"} onClick={modalState.close} />
            <DesideButton
              title={"決定"}
              onClick={(e: React.FormEvent<HTMLFormElement>) => {
                handleRegisterSubmit(e);
              }}
            />
          </ButtonAlign>
        </>
      }
    />
  );
};

export default AdminRegisterModal;

const ButtonAlign = styled.div`
  display: flex;
`;
const DesideButton = styled(Button)``;
const CancelButton = styled(Button)``;
